import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { filter, map } from 'rxjs/operators';
import { ActivatedRoute, NavigationEnd, Route, Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { merge, Observable, Subscription } from 'rxjs';
import { UserService } from '../../../core/services/user.service';
import { TitleService } from '../title.service';
import { LayoutService } from '../layout.service';

@Component({
    selector: 'cmn-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

    private subscriptions: Subscription = new Subscription();
    public pageTitle: Observable<string>;
    public showHeader = false;
    @HostBinding('class.hidden') public isHidden = false;
    @Input() breadcrumbsMaxLength: number = 4;

    constructor(
        private userService: UserService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private titleService: TitleService,
        private layoutService: LayoutService
    ) {
        this.pageTitle = this.titleService.getPageTitleObservable();
        this.subscriptions.add(
            merge(
                this.router.events,
                this.userService.userIsLogin$
            )
                .pipe(
                    filter((value: any) => {
                        return value instanceof NavigationEnd || value;
                    })
                )
                .pipe(
                    map(() => {
                        this.titleService.setPageTitle(this.preparePageTitle(this.activatedRoute.root));
                        this.showHeader = this.pageTitle !== null;
                    })
                )
                .subscribe()
        );

        layoutService.setHeader(this);
    }

    private preparePageTitle(route: ActivatedRoute) {
        let currentRoute: ActivatedRoute = route;
        let title: string = this.getPageTitleFromRoute(currentRoute);

        while (!isNullOrUndefined(currentRoute.firstChild)) {
            currentRoute = currentRoute.firstChild;
            const routeTitle = this.getPageTitleFromRoute(currentRoute);
            title = routeTitle ? routeTitle : title;
        }

        return title;
    }

    private getPageTitleFromRoute(activatedRoute: ActivatedRoute) {
        const routeConfig: Route = activatedRoute.routeConfig;

        if (!routeConfig) {
            return null;
        }

        const data = isNullOrUndefined(routeConfig.data) ? [] : routeConfig.data;

        return isNullOrUndefined(data['pageTitle']) ? null : data['pageTitle'];
    }

    ngOnInit() {
    }

    public hide() {
        this.isHidden = true;
    }
    public show() {
        this.isHidden = false;
    }
}
